<template>
  <div class="userWrap">
    <h4>修改邮箱</h4>

    <div class="formWrap">
      <el-form :model="resetEmailForm" :rules="rules" ref="resetEmailForm" label-width="0" class="resetEmailForm">

        <!-- 新手机号码 -->
        <el-form-item prop="email" class="emailItem">
          <p>新电子邮箱</p>
          <el-input v-model="resetEmailForm.email" size="medium" autocomplete="off"></el-input>
        </el-form-item>

        <!-- 新手机验证码 -->
        <el-form-item prop="code">
          <p>邮箱验证码</p>
          <el-input v-model="resetEmailForm.code" size="medium" autocomplete="off">
            <template slot="append">
              <span @click="getOPT">{{optWords}}</span>
            </template>
          </el-input>
        </el-form-item>


        <!-- 支付密码 -->
        <el-form-item prop="password">
          <p>支付密码</p>
          <el-input type="password" v-model="resetEmailForm.password" size="medium" autocomplete="off"></el-input>
        </el-form-item>

        <div class="submit">
          <el-button type="primary" size="medium" @click="regForm('resetEmailForm')">
            {{pc_lang.Confirm_submission}}
          </el-button>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import * as API_USER from '@/api/user'
import * as RegExp from '@/utils/RegExp'

export default {
  name: 'UserResetEmail',
  components: {

  },
  data() {
    return {
      resetEmailForm: {
        email: '',
        code: '',
        password: ''
      },
      optTimer: null,
      optBool: 1,
      optWords2: '',
    }
  },
  computed: {
    rules() {
      let validatePay = (rule, value, callback) => {
        if (value === '') {
        callback(new Error(this.pc_lang.Enter_the_password));
      } else if( !RegExp.payword.test(value) ) {
        callback(new Error(this.pc_lang.Password_consists_of_6_digits));
      }else {
        callback();
      }
      };
      // email验证
      let validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_your_email_address));
        } else if (!RegExp.email.test(value)) {
          callback(new Error(this.pc_lang.Enter_your_correct_email_address));
        } else {
          API_USER.checkEmail({email: value}).then(res=> {
            if (res.data) {
              callback();
            } else {
              callback(new Error(this.pc_lang.The_email_has_been_registered));
            }
          },rej=> {
            callback(new Error(this.pc_lang.Enter_your_correct_email_address));
          })
        }
      };
      return {
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        code: [
          { required: true, message: this.pc_lang.Enter_verification_code, trigger: 'blur' },
          { min: 6, max: 6, message: '长度为6个字符', trigger: 'blur' }
        ],
        password: [
          { validator: validatePay, trigger: 'blur' }
        ]
      }
    },
    // 验证码单词
    optWords: {
      get() {
        return this.optWords2 == "" ? this.pc_lang.Get_verification_code : this.optWords2
      },
      set(val) {
        this.optWords2 = val
      }
    }
  },
  async mounted() {

  },
  beforeDestroy() {
    try{
      window.clearInterval(this.optTimer)
    }catch(err){}
    this.optTimer = null
  },
  created() {

  },
  methods: {
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submit()
        }
      })
    },
    /* 获取验证码 */
    getOPT() {
      if (!!!this.resetEmailForm.email) {
        this.$message_box.alert('请填写新的电子邮箱', 'Error', {
          type: 'error',
          callback: ()=> {

          }
        })
        return false
      }
      if (!Array.from(document.querySelector('.emailItem').classList).includes('is-error')) {
        if (this.optBool) {
          this.optBool = 0
          const { email } = this.resetEmailForm
          API_USER.verify_email( email ).then(res=>{
            let num = res.data || 120
            let optTimer = setInterval(()=> {
              num--
              let word = this.pc_lang.Get_the_code_after_3s.replace(/3/, num)
              if (num <= 0) {
                clearInterval(optTimer)
                this.optWords = this.pc_lang.Get_verification_code
                this.optBool = 1
                return false
              }else{
                this.optWords = word
              }
            }, 1000)
          },rej=> {
            this.optBool = 1
            try{
              this.$message.error(rej.msg)
            }catch(err){}
          })
        }
      }
    },
    /* submit */
    submit() {
      let params = Object.assign({}, this.resetEmailForm)
      params.password = md5(params.password)
      API_USER.resetEmail(params).then(res=> {
        this.signOut()
        this.$message_box.alert('绑定邮箱修改成功，请使用新邮箱登录！', 'Success', {
          type: 'success',
          callback: ()=> {

          }
        })
      },
      rej=> {
        this.$message.error(rej.msg)
      })
    },
    /* 退出登录 */
    signOut() {
      this.$store.dispatch('token', {})
      this.$store.dispatch('user', {})
      if (this.$route.name != 'Index') {
        this.$router.push({name: 'Index'})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>